import {EStatus} from "../../models/user";
import React from "react";
import {VscCircleFilled} from "react-icons/vsc";
import {Chip} from "@mui/material";

interface IPropsChipStatus {
  status: EStatus | boolean | undefined;
}

export default function ChipStatus(props : IPropsChipStatus){
  const status = {name : "Inativo", backgroundColor : "#F0F0F0", color : "#000000"};

  if (props.status === EStatus.INACTIVE  ){
    status.name = "Inativo";
    status.backgroundColor = "#BFBFBF";
    status.color = "#000000";
  }
  else if (props.status == EStatus.ACTIVE || props.status === true){
    status.name = "Ativo";
    status.backgroundColor = "#DEFEE5";
    status.color = "#4cff3d";
  }
  else if (props.status == EStatus.PENDING){
    status.name = "Pendente";
    status.backgroundColor = "#F0D0B1";
    status.color = "#fe4c01";
  }
  else if (props.status == EStatus.BLOCKED || !props.status){
    status.name = !props.status ? "Inativo" : "Bloqueado";
    status.backgroundColor = "#FFD7D7";
    status.color = "#FF0000";
  }

  return(
    <>
      <Chip sx={{ backgroundColor : status.backgroundColor}}
            avatar ={<VscCircleFilled color={status.color}/>}
            label={status.name}/>
    </>
  );
}
